<template>
    <a-card title="创新自测信息">
        <a-form ref="ruleForm" :model="form" :rules="rules" :isModal="false">
            <!--可编辑区域 start-->
            <a-row :gutter="24">
                <div class="hidden">
                    <a-form-item label="id" name="id">
                        <a-input v-model:value="form.id" />
                    </a-form-item>
                    <a-form-item label="companyCode" name="companyCode">
                        <a-input v-model:value="form.companyCode" />
                    </a-form-item>
                </div>
                <a-col :span="12">
                    <a-form-item label="职工人数" name="staffNum">
                        <a-input-number v-model:value="form.staffNum" placeholder="请输入职工人数" style="width: 100%"/>
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="纳税(万元)" name="taxAmount">
                        <a-input-number v-model:value="form.taxAmount" placeholder="请输入纳税金额" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="营收(万元)" name="revenue">
                        <a-input-number v-model:value="form.revenue" placeholder="请输入营收金额" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="高技能人才数" name="skillMaster">
                        <a-input-number v-model:value="form.skillMaster" style="width: 100%" placeholder="请输入技能大师(高技能人才)" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="是否科技中小企业" name="isSmallTech">
                        <a-radio-group v-model:value="form.isSmallTech">
                            <a-radio :value="0">是</a-radio>
                            <a-radio :value="1">否</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="是否高新技术企业" name="isHighNew">
                        <a-radio-group v-model:value="form.isHighNew">
                            <a-radio :value="0">是</a-radio>
                            <a-radio :value="1">否</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>



                <a-col :span="12">
                    <a-form-item label="知识产权数量" name="intellectualProperty">
                        <a-input-number v-model:value="form.intellectualProperty" placeholder="请输入知识产权数量" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="科技成果数量" name="scienceAchievements">
                        <a-input-number v-model:value="form.scienceAchievements" placeholder="请输入科技成果数量" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="项目登记" name="projectRegistration">
                        <a-input-number v-model:value="form.projectRegistration" placeholder="请输入项目登记数量" style="width: 100%"/>
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="成果转化项目数" name="achievementTransformationProject">
                        <a-input-number v-model:value="form.achievementTransformationProject" placeholder="请输入成果转化项目数量" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col span="24">
                    <a-form-item :wrapper-col="{ offset: 8, span: 16 }">
                        <a-button type="primary" html-type="submit" @click="onSubmit">
                            提交
                        </a-button>
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>
    </a-card>
</template>
<script>
import { formMixin } from "@/mixins";
import { extendApi} from "@/api/companyService";
// import dataCheck from "@/utils/dataCheck";

export default {
    name: "companyInfo",
    components: {  },
    mixins: [formMixin],
    data() {
        return {
            form: {
                id: null,
                staffNum: null,
                taxAmount: null,
                revenue: null,
                isSmallTech: null,
                isHighNew: null,
                skillMaster: null,
                intellectualProperty: null,
                scienceAchievements: null,
                projectRegistration: null,
                achievementTransformationProject: null,

                companyCode:this.$ls.get("companyCode")

            },
            rules: {
                id:[],
                staffNum:[],
                taxAmount:[],
                revenue:[],
                isSmallTech:[],
                isHighNew:[],
                skillMaster:[],
                intellectualProperty:[],
                scienceAchievements:[],
                projectRegistration:[],
                achievementTransformationProject:[],

                companyCode:[]
            },
            submitUrl: extendApi.saveOrUpdate
        }
    },
    created() {
        this.getCorpInfo()
    },
    methods: {
        getCorpInfo() {
            this.getAction({
                url: extendApi.detail,
                params:{
                    companyCode:this.$ls.get("companyCode")
                }
            }).then(res => {
                this.form = res
            })
        },
    },
}
</script>
<style lang="less" scoped></style>
